
import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      animate: false,
    }
  },
  mounted() {
    window.setTimeout(() => {
      this.animate = true
    }, 0)
  },
})
